import { Config } from './config.model';

export const config: Partial<Config> = {
  api: {
    url: 'https://maestro-webapi-auto.oplog.cloud',
    terminalWebSocketUrl: 'wss://terminal.ras.oplog.cloud:6161/',
  },
  auth: {
    domain: 'https://oplog.kinde.com',
    client_id: '3ae471e315584df88787c43a5379a3f8',
    redirect_uri: 'https://maestro-automation.oplog.app/callback',
    logout_uri: 'https://maestro-automation.oplog.app/login',
    audience: 'https://maestro-api',
    scope: 'openid email profile offline',
    org_code: 'org_77588315903', // Default OPLOG organization
  },
};
